/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { attachmentsTypeNames } from 'newJs/config/theme';
const { VIEW_MODE } = ATTACHMENTS;
import { ATTACHMENTS } from 'newJs/config';

const stylesFor = {
    grid: css`
        ${({ theme: { gridGutterWidth }}) => `
            margin-top: ${gridGutterWidth - 1}px;
            margin-bottom: ${gridGutterWidth - 1}px;
            padding-right: ${3 * gridGutterWidth + 2}px;
            padding-left: ${3 * gridGutterWidth + 2}px;
        `}
        position: relative;
        width: 100%;
        word-break: break-word;

        .item-extension-icon {
            position: absolute;
            left: 0;
            top: 0;
            font-size: 16px;
            line-height: 1;
        }

        .item-name__value {
            line-height: 1.45em;
        }

        /* Hack for MS IE10 - 11 */
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            word-wrap: break-word;
        }
    `,
    inline: css`
        padding: ${({ theme }) => theme.gridGutterWidth - 1}px 0;
        white-space: nowrap;

        .item-extension-icon {
            align-self: flex-start;
            font-size: 16px;
            line-height: 1;
            margin-right: ${({ theme }) => `${theme.gridGutterWidth - 2}px`};
        }
    `
};

const Name = styled.a`
    color: var( --theme-attachment-item-text);
    flex-grow: 1;
    margin: 0;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    display: flex;
    ${({ theme }) => theme.currentViewMode === VIEW_MODE.GRID
        ? stylesFor.grid
        : stylesFor.inline
    }
    &:hover {
        color: var(--attachments-text-active);
    }

    .item-extension-icon {
        &--unknown {
            color: var(--color-fire);
        }
        ${() => {
            // Loop through the attachment colors and generate the background styles dynamically
            return Object.keys(attachmentsTypeNames).map((type) => {
                const color = attachmentsTypeNames[type];
                return `
                &--${type} {
                    color: var(--${color});
                }
                `;
            }).join('');
        }}
    }
`;

export default Name;
